<template>
    <td class="schedule-cell" :class="[stateClass, fadeClass]">
        <button
            type="button"
            :aria-label="ariaLabel"
            :disabled="done"
            @click="cycle"
        >
            <span
                v-if="done"
                class="material-symbols-outlined done-icon"
                aria-hidden="true"
            >
                check
            </span>
            <template v-else>{{ shortLabel }}</template>
        </button>
    </td>
</template>

<script>
export default {
    name: "ScheduleGridCell",
    props: {
        modelValue: {
            type: String,
            default: null,
        },
        month: {
            type: String,
            required: true,
        },
        overlaps: {
            type: Array,
            required: false,
            default: () => [],
        },
        hint: {
            type: Boolean,
            default: false,
        },
        done: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
    computed: {
        schedulePreferences() {
            return this.$enumOptions("schedule_preference");
        },
        cycleOptions() {
            return [null, ...this.schedulePreferences.map(([value]) => value)];
        },
        label() {
            const found = this.schedulePreferences.find(
                ([value]) => value === this.modelValue
            );
            return found ? found[1] : "";
        },
        shortLabel() {
            return this.label ? this.label.charAt(0) : "";
        },
        stateClass() {
            if (this.done) {
                return "state-done";
            }
            return this.modelValue ? `state-${this.modelValue}` : "";
        },
        fadeClass() {
            if (this.done || this.modelValue) {
                return false;
            }
            if (this.overlaps.length) {
                if (this.overlaps.every((c) => c === "commit")) {
                    return "fade-commit";
                }
                if (this.overlaps.some((c) => c === "avoid")) {
                    return "fade-avoid";
                }
                if (
                    this.overlaps.every((c) => c === "commit" || c === "plan")
                ) {
                    return "fade-plan";
                }
            }
            return this.hint ? "fade-hint" : false;
        },
        ariaLabel() {
            if (this.done) {
                return `${this.month}: Done`;
            }
            const state = this.label || "Not planned";
            return this.hint
                ? `${this.month}: ${state}, good season`
                : `${this.month}: ${state}`;
        },
    },
    methods: {
        cycle() {
            if (this.done) {
                return;
            }
            const index = this.cycleOptions.indexOf(this.modelValue);
            const next =
                this.cycleOptions[(index + 1) % this.cycleOptions.length];
            this.$emit("update:modelValue", next);
        },
    },
};
</script>
